import { useEffect } from "react";
import { useLocation } from 'react-router-dom';

const PageTitle = ({ title, description }) => {

    const location = useLocation();

    useEffect(() => {
        document.title = title;

        if (description) {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.setAttribute('name', 'description');
                document.head.appendChild(metaDescription);
            }
            metaDescription.setAttribute('content', description);
        }
    }, [location, title, description]);

  return null;
}

export default PageTitle